export const emptyFaq: Faq = {
    _id: '',
    defaultLang: 'en',
    weight: 0,
    translations: []
}

export interface FaqTranslation {
    lang: 'en' | 'es' | 'ca' | 'ru';
    title: string;
    body: string;
}

export interface Faq {
    _id: string;
    defaultLang: 'en' | 'es' | 'ca' | 'ru';
    weight: number;
    translations: FaqTranslation[];
}
